
import moment from 'moment'
import Vue, { PropType } from 'vue'
import api from '@/api/api'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import SpinnerLoader from '@/components/SpinnerLoader.vue'
import { Connector, Project, ProjectType } from '@/types/main'
import { CONNECTOR_TYPES } from '@/vars/general'
import get from 'lodash/get'
import DoctorReportLorealCard from '../components/DoctorReportLorealCard.vue'
import { DoctorReportLorealMarkData } from '../types'
import { DOCTOR_REPORT_LOREAL_MARK_INFO } from '../consts'
import CustomActivatorSelect from '../../../components/inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../../../components/inputs/BaseInputOutlined.vue'
import VideoHelper from '@root/src/components/VideoHelper.vue'

export default Vue.extend({
    name: 'DoctorReportLoreal',
    components: {
        Breadcrumbs,
        SpinnerLoader,
        DoctorReportLorealCard,
        CustomActivatorSelect,
        BaseInputOutlined,
        VideoHelper
    },

    data: () => ({
        pageLoading: false,
        dashboardDataLoading: false,
        dashboardData: [],
        filialList: [] as any[],
        selectedProjectId: null as null | string,
        showVideoHelp: true
    }),
    watch: {},
    computed: {
        projectType(): ProjectType {
            return this.$store.getters.projectType;
        },
        networkProjects(): Project[] {
            return this.$store.getters.networkProjects;
        },
        pseudoNetworkProjects(): Project[] {
            return this.$store.getters.pseudoNetworkProjects;
        },
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        connector(): Connector | undefined {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.GCB2)
        },
        isVideoHintHidden(): boolean {
            return this.connector?.videoHintDisabled
        },
        breadcrumbs(): Array<any> {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'Доктор для Лореаль',
                    to: '',
                    disabled: true,
                },
            ]
        },
        marks(): DoctorReportLorealMarkData[] {
            const fieldsWithMonth = [
                'trafficTotal', 'trafficParik', 'trafficManicure', 'trafficOther',
                'haircutsCnt', 'coloringCnt', 'haircareCnt',
                'avgCheckSumTotal', 'avgCheckSumParik',
                'newCountByMonth', 'newCountByMonthParikAbsolute', 'newCountByMonthParikCross',
                'itemsCount', 'itemsCountParik'
            ]

            return Object.keys(this.dashboardData)
                .map(key => {
                    const markInfo = get(DOCTOR_REPORT_LOREAL_MARK_INFO, key)
                    if (!markInfo) return

                    let value: string | number | null | undefined = undefined
                    let compareValue: string | number | null | undefined = undefined
                    let quarterValue: string | number | null | undefined = undefined
                    let quarterCompareValue: string | number | null | undefined = undefined

                    if (fieldsWithMonth.includes(key)) {
                        const monthKey = `${key}Month`
                        const prevYearKey = `${key}PrevYear`
                        const monthPrevYearKey = `${monthKey}PrevYear`

                        value = get(this.dashboardData, monthKey) as string | number | null | undefined
                        compareValue = get(this.dashboardData, monthPrevYearKey) as string | number | null | undefined
                        quarterValue = get(this.dashboardData, key) as string | number | null | undefined
                        quarterCompareValue = get(this.dashboardData, prevYearKey) as string | number | null | undefined
                    } else {
                        value = get(this.dashboardData, key) as string | number | null | undefined
                        compareValue = get(this.dashboardData, `${key}PrevYear`) as string | number | null | undefined
                    }

                    const markData: DoctorReportLorealMarkData = {
                        ...markInfo,
                        id: key,
                        value: value,
                        ...(compareValue !== undefined && { compareValue }),
                        ...(quarterValue !== undefined && { quarterValue }),
                        ...(quarterCompareValue !== undefined && { quarterCompareValue })
                    }

                    return markData
                })
                .filter(el => el) as DoctorReportLorealMarkData[]
        },
    },
    methods: {
        async initData(initital?: boolean) {
            this.dashboardDataLoading = true
            if (initital) {
                this.filialList =
                    this.projectType === 'network' ? this.networkProjects.filter(el => !el.isMain) : this.projectType === 'pseudo_network' ? this.pseudoNetworkProjects : this.networkProjects
                this.selectedProjectId = this.project.id
            }
            const { data, error } = await api.gcb2.getDoctorReportLorealData({
                projectId: this.selectedProjectId!,
            })
            if (error) {
                this.$store.dispatch('callNotify', 'Ошибка')
            }
            this.dashboardData = data
            this.dashboardDataLoading = false
        },
        setVideoHelepVisible(value) {
            this.showVideoHelp = value
        }
    },
    async mounted() {
        this.initData(true)
    },
})
